module.exports = __webpack_public_path__ + "img/Birte-Schmidt-v2-800.461ce288.jpg";